var map = {
	"./front/1.png": 7175,
	"./front/2.png": 1150,
	"./front/3.png": 3639,
	"./front/4.png": 2545,
	"./front/5.png": 8338,
	"./side/1.png": 4201,
	"./side/2.png": 948,
	"./side/3.png": 8593,
	"./side/4.png": 8740,
	"./side/5.png": 3188,
	"./side/6.png": 1716
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1913;